import { render, staticRenderFns } from "./Foreground.vue?vue&type=template&id=31ec3ec4&"
import script from "./Foreground.vue?vue&type=script&lang=js&"
export * from "./Foreground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports